import { render, staticRenderFns } from "./DashboardLawyer.vue?vue&type=template&id=84b70a7c&scoped=true&"
import script from "./DashboardLawyer.vue?vue&type=script&lang=js&"
export * from "./DashboardLawyer.vue?vue&type=script&lang=js&"
import style0 from "./DashboardLawyer.vue?vue&type=style&index=0&id=84b70a7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b70a7c",
  null
  
)

export default component.exports